<template>
  <div class="content">
    <div class="filter_box">
      <div class="row">
        <!-- 考生信息 -->
        <div class="item"  style="padding-left:20px">
          <div class="own_name">考生信息：</div>
          <el-input v-model="keyword" @change="keywordSearch" placeholder="可搜索姓名或手机号"></el-input>
        </div>
        <!-- 批次 -->
        <div class="item">
          <div class="own_name">批次：</div>
          <el-select v-model="appraisalId" placeholder="请选择批次">
            <el-option
              v-for="(item,index) in batchList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <!-- 工种 -->
        <div class="item">
          <div class="own_name">工种：</div>
          <el-select v-model="occupation" placeholder="请选择工种">
            <el-option
              v-for="(item,index) in occupationList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div>
        <!-- 等级 -->
        <div class="item">
          <div class="own_name">等级：</div>
          <el-select placeholder="请选择等级" v-model="level">
            <el-option
              v-for="(item,index) in levelList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <!-- 科目 -->
        <div class="item">
          <div class="own_name">科目：</div>
          <el-select v-model="subject" placeholder="请选择科目">
            <el-option
              v-for="(item,index) in subjectList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="own_name">考试动态：</div>
          <el-select placeholder="请选择考试动态" v-model="status">
            <el-option
              v-for="(item,index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="button_box">
      <el-button type="primary" @click="getExport()">导出</el-button>
      <!-- <download-excel
        class="excel"
        :data="examarr"
        :fields="json_data"
        :header="title"
        name="考生动态表格.xls"
      >
      <el-button type="primary">导出</el-button>
      </download-excel> -->
    </div>
    <div class="content_box">
      <table class="tablecontain">
        <thead>
          <tr class="tablehead">
            <th class="name">序号</th>
            <th>姓名</th>
            <th>手机号</th>
            <th>批次</th>
            <th>工种</th>
            <th>等级</th>
            <th class="sub">科目</th>
            <th>考试时间</th>
            <th class="test">考试动态</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tablebody" v-for="(item, index) in formatData(examarr)" :key="index">
            <td>{{ item.serial }}</td>
            <td>{{ item.examName }}</td>
            <td>{{ item.examPhone }}</td>
            <td>{{ item.appraisalBatchName }}</td>
            <td>{{ item.examSubiectName }}</td>
            <td>{{ item.examRank}}</td>
            <td>{{ item.subject }}</td>
            <td>{{ item.examTime }}</td>
            <td><span 
              @click="checkReason(item)" 
              :class="{cancellation:item.examDynamic==='invalidated'}"
            >{{ item.examDynamicText }}</span></td>
          </tr>
        </tbody>
      </table>
      <div v-if="!examarr.length" style="width:100%;margin-top:20px;text-align:center;color:grey">暂无数据</div>
      <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
// import {downloadBlob} from '@/utils/util.js'
import { ElMapExportTable } from "table-excel";

export default {
  data() {
    return {
      examarr: [],
      statusObj: {
        'normal': '考试中',
        'exception': '考试中',
        'miss': '未考试',
        'submitted': '已考试',
        'tookNumber': '已取号',
        'invalidated': '成绩已作废'
      },
      statusList: [
        {'name': '全部动态', 'value': ''},
        {'name': '考试中', 'value': 'normal'},
        {'name': '未考试', 'value': 'miss'},
        {'name': '已考试', 'value': 'submitted'},
        {'name': '已取号', 'value': 'tookNumber'},
        {'name': '成绩已作废', 'value': 'invalidated'}
      ],
      occupationList: [],  
      occupation: '',
      levelList: [],
      level: '',
      subjectList: [],
      batchList: [],
      listCount: 0,
      subject: '',
      status: '',
      keyword: '',
      page: 1,
      limit: 12,
      appraisalId: '',
      // title: '考生动态表格',
      // json_data: {
      //   '序号': 'serial',
      //   '姓名': 'examName',
      //   '手机号': 'examPhone',
      //   '批次': 'appraisalBatchName',
      //   '工种': 'examSubiectName',
      //   '等级': 'examRank',
      //   '科目': 'subject',
      //   '考试时间': 'examTime',
      //   '考试动态': 'examDynamic',
      // }
    }
  },
  computed: {
    levelFlag: function() {
      return this.levelList.length > 1
    },
    subjectFlag: function() {
      return this.subjectList.length > 1
    }
  },
  watch: {
    appraisalId: function() {
      let currentBatchList = this.batchList.filter(ele=> ele.id === this.appraisalId)
      this.occupationList = [{'name': currentBatchList[0].occupationName}]
      this.levelList = [{'name': currentBatchList[0].occupationLevel}]
      this.subjectList = [{'name': '全部科目', 'value': ''}]
      let subjectList = currentBatchList[0].subject
      subjectList.forEach(ele => {
        ele.value = ele.name
      })
      this.subjectList = this.subjectList.concat(subjectList)
      this.occupation = this.occupationList[0].name
      this.level = this.levelList[0].name
      this.getStudentList()
    },
    subject: function() {
      this.getStudentList()
    },
    status: function() {
      this.getStudentList()
    }
    
  },
  created(){
    this.getBatchList()
  },
  methods: {
    getBatchList: function() { //查询现有批次信息
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.success){
          this.batchList = this.batchList.concat(res.data.data)
          this.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
          this.getStudentList()
        }
      })
    },
    getStudentList: function() {  //查询列表
      let params = {
        keyword: this.keyword, //关键字
        subject: this.subject, //科目
        status: this.status, //动态 未开考 noTest 未签到 noNumber
        page: this.page,
        limit: this.limit,
        appraisalId: this.appraisalId
      }
      this.$http.get('/registration/examiees/status', { params }).then(res => {
        let list = res.data.data.resultList || []
        this.listCount = res.data.data.totalCount
        if(res.data.success){
          list.forEach((element,index) => {
            element.serial = index + 1
            element.examDynamicText = this.statusObj[element.examDynamic]
          })
          this.examarr = list
        }
      })
    },
    handleSizeChange: function(val) {
      this.page = 1
      this.limit = val
      this.getStudentList()
    },
    handleCurrentChange: function(val) {
      this.page = val
      this.getStudentList()
    },
    keywordSearch: function() {
      this.page = 1
      this.getStudentList()
    },
    formatData: function(arr) {
      return arr.slice((this.page-1)*this.limit, this.page*this.limit)
    },
    checkReason: function(item) { //查看成绩作废原因
      if(item.examDynamic === 'invalidated'){
        this.$http.get('/examination/reason/invalidate', {params:{reExamOrderId:item.reExamOrderId}}).then(res => {
          if(res.data.success){
            this.$alert(res.data.data.invalidateReason, '成绩作废原因', {
              confirmButtonText: '确定',
            })
          }
        }).catch(() => {
          this.$message({
            type: 'warning',
            message: `未知异常`
          })
        })
      } 
    },
    // 导出
    getExport(){
      let data = this.examarr; // 这里面是数据列表
      const column = [
        { title: "序号", dataIndex: "serial" }, // dataIndex为数据列表中的数据字段
        { title: "姓名", dataIndex: "examName" },
        { title: "手机号", dataIndex: "examPhone" },
        { title: "批次", dataIndex: "appraisalBatchName" },
        { title: "工种", dataIndex: "examSubiectName" },
        { title: "等级", dataIndex: "examRank" },
        { title: "科目", dataIndex: "subject" },
        { title: "考试时间", dataIndex: "examTime" },
        { title: "考试动态", dataIndex: "examDynamicText" }
      ];
      const instance = new ElMapExportTable(
        { column, data }
        // { progress: progress => console.log(progress) }// 进度条回调
      );
      instance.download("考生动态"); // 导出的文件名
    }
  }
}
</script>

<style scoped lang="less">
*{
  box-sizing: border-box;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  padding-top: 30px;
  min-width: 1980px;
  height: 100vh;
  background-color: white;
}
.filter_box {
  width: 100%;
  padding: 20px;
  .row{
    width: 100%;
    justify-content: space-between;
    display: flex;
    .item{
      display: flex;
      padding: 15px 40px 15px 0px;
      align-items: center;
    }
  }
  
}

.content_box{
  padding: 0 @checkringht @checkringht @checkringht;
  background: @whitee;
}
.own_name{
  color: @leftcolor;
  font-weight: 600;
  width: 200px;
  text-align: end;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}

#top {
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}

.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
.flexcontain{
  display: flex;
  margin-top: @checkringht;
  // height: 80px;
  justify-content: center;
  align-items: center;
    
}
.own_input,.cat-choose{
  flex: 1;
  height: @minboxgao;
  line-height: @minboxgao;
}
.tablecontain{
  width: 100%;
  border-left: 1px solid @tableborder;
  border-top: 1px solid @tableborder;
  border-spacing: 0;
  margin-top: @minboxgao;
  .tablebody:nth-child(2n+2){
    background: @tablecolor;
  }
}
 .tablehead>th,.tablebody>td{
  border-right: 1px solid @tableborder;
  border-bottom: 1px solid @tableborder;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.tablebody>td {
  padding: 20px;
}
.tablebody>td>img{
  width: 30px;
  height: 15px;
  margin-left: 4px;
}
.tablehead{
  font-size: 24px;
}
.tablehead .sub{
  width: 95px;
  height: 50px;
}
.tablehead .test{
  width: 110px;
  height: 100px;
}
.tablehead .name {
  width: 96px;
}

.filter_box ::v-deep .el-input__inner{
  width: 300px;
}
.cancellation {
  cursor: pointer;
  color: #64B5F6;
}
.button_box{
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
</style>
